import { Fragment } from 'react';
import PropTypes from 'prop-types';

import OptionList from 'jl-design-system/components/option/OptionList';
import RadioButton from 'jl-design-system/components/radio-button/RadioButton';

import { ConnectedWithAnalytics } from '../../questions/with-analytics.hoc';

import styles from './RadioGroup.scss';

export const RadioGroup = ({ id: questionId, options = [], value, onChange, onBlur }) => (
  <Fragment>
    <OptionList name={questionId} isButtonList={false} isControlled>
      {options.map(({ displayName, isDefault }) => {
        const isChecked = value ? value === displayName : isDefault;

        return (
          <RadioButton
            label={displayName}
            value={displayName}
            isControlled
            checked={isChecked}
            onBlur={onBlur}
            onChange={onChange}
            key={displayName}
            className={styles.RadioButton}
            labelClassName={styles.Label}
            name={questionId}
          />
        );
      })}
    </OptionList>
  </Fragment>
);

RadioGroup.propTypes = {
  id: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
};

export const RadioQuestionWithAnalytics = ConnectedWithAnalytics()(RadioGroup);
